<template>
  <div class="page-container">
    <div class="content">
      <div class="card header-card">
        <div class="product-info">
          <div class="img-box">
            <img src="@/assets/yjdd.png" />
          </div>
          <div class="info-text">
            <div class="card-title">设备编号：{{ sn || "" }}</div>
            <div class="prices-row">
              <span class="price-item"
                >押金 <span class="bold">¥{{ depositAmount }}</span></span
              >
              <span class="price-item"
                >租金 <span class="bold">¥{{ rentAmount }}</span></span
              >
            </div>
          </div>
        </div>

        <div class="timeline-box">
          <div class="time-node left">
            <div class="hollow-ring"></div>
            <div class="node-label">开始</div>
            <div class="node-date">{{ startDate }}</div>
          </div>

          <div class="progress-container">
            <div
              class="line"
              :style="{
                background: `linear-gradient(to right, var(--primary-color), ${primaryColor80} 50%, ${primaryColor20})`,
              }"
            ></div>
            <div class="pill-badge">{{ validityDays }}月</div>
          </div>

          <div class="time-node right">
            <div class="hollow-ring"></div>
            <div class="node-label">结束</div>
            <div class="node-date">{{ endDate }}</div>
          </div>
        </div>
      </div>

      <div class="card info-list">
        <div class="section-header">免押信息</div>
        <div class="cell">
          <div class="cell-label">押金方式</div>
          <div class="cell-value flex-center" v-if="depositType == 'C'">
            <img src="@/assets/depositFreeBlue.png" />
            <span class="cell-tip1">芝麻信用免押金</span>
          </div>

          <div class="cell-value flex-center" v-else>
            <img src="@/assets/depositFreeLock.png" />
            <span class="cell-tip2">冻结资金</span>
          </div>
        </div>
        <div class="cell">
          <div class="cell-label">状态</div>
          <div class="cell-value">{{ statusTipName }}</div>
        </div>
        <div class="cell">
          <div class="cell-label">授权时间</div>
          <div class="cell-value">{{ expireTime }}</div>
        </div>

        <div class="cell" v-if="completeTime">
          <div class="cell-label">完结时间</div>
          <div class="cell-value">{{ completeTime }}</div>
        </div>

        <div class="cell no-border">
          <div class="cell-label">订单号</div>
          <div class="cell-value flex-center">
            <span class="order-text">{{ orderNo }}</span>
            <button class="copy-btn" @click="copyOrderNo">复制</button>
          </div>
        </div>
      </div>

      <div class="card deduction-card" v-if="orderList && orderList.length > 0">
        <div class="section-header">扣款记录</div>

        <div class="deduction-list">
          <div
            class="deduction-item"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="d-time-row">{{ item.time }}</div>

            <div class="d-info-row">
              <span class="d-label">扣款金额</span>
              <span class="d-value money">{{ item.amount }}</span>
            </div>

            <div class="d-info-row">
              <span class="d-label">状态</span>
              <span class="d-value status" :class="item.statusClass">
                {{ item.statusText }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="buttonTitle.length">
      <div class="footer-placeholder"></div>
      <div class="footer-fixed">
        <button
          class="submit-btn"
          :style="{ boxShadow: `0 4px 16px ${primaryShadow30}` }"
          @click="handleSubmit"
        >
          {{ buttonTitle }}
        </button>
      </div>
    </template>

    <transition name="fade">
      <div class="custom-toast" v-if="toastVisible">
        {{ toastMessage }}
      </div>
    </transition>

    <van-overlay :show="finshShow" :z-index="2000" @click="closeAlertAction">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="block-tip">提示</p>
          <p class="block-message">是否确认申请完结免押订单？</p>

          <div class="button-group">
            <button class="btn-cancel" @click="cancelClick">取消</button>
            <button class="btn-confirm" @click="okClick">确定</button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  getListofUnsecuredOrderDetail,
  getUnsecuredOrderDetailButton,
  requestApplicationCompletedAction,
  getListDeductionRecord,
} from "@/api/user";

export default {
  data() {
    return {
      sn: "",
      depositAmount: "",
      rentAmount: "",
      startDate: "",
      endDate: "",
      validityDays: "",
      depositType: "",
      depositTypeName: "",
      statusType: 0,
      statusTipName: "",
      statusName: "",
      expireTime: "",
      timeoutTime: "",
      completeTime: "",
      remark: "",
      createTime: "",
      completeTime: "", //完结时间

      toastVisible: false,
      toastMessage: "",
      primaryShadow30: "rgba(253, 141, 50, 0.3)", // 兜底颜色，实际会通过 mounted 计算

      orderList: [],
      orderNo: "",
      buttonTitle: "",
      buttonType: 0,
      finshShow: false,
    };
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo;
    // 设置主题色阴影变量
    this.setPrimaryShadowVariables();
    // 计算一次 JS 用的阴影颜色
    this.primaryShadow30 = this.getThemeColor(0.3);

    this.requestDetailAction();
  },

  computed: {
    // 动态计算：透明度 0.8 (用于进度条中间点)
    primaryColor80() {
      return this.getThemeColor(0.8);
    },
    // 动态计算：透明度 0.2 (用于进度条终点)
    primaryColor20() {
      return this.getThemeColor(0.2);
    },
  },

  methods: {
    requestDetailAction() {
      getListofUnsecuredOrderDetail({
        orderNo: this.orderNo,
      }).then((res) => {
        this.orderNo = res.orderNo;
        this.sn = res.sn;
        this.depositAmount = res.depositAmount;
        this.rentAmount = res.rentAmount;
        this.startDate = res.startDate;
        this.endDate = res.endDate;
        this.validityDays = res.validityDays;
        this.depositType = res.depositType;
        this.depositTypeName = res.depositTypeName;
        this.statusType = res.status;

        let statusName = "";
        // 注意：原代码此处是 res.start，建议改为 res.status
        switch (res.status) {
          case 1:
            statusName = "待下单";
            break;
          case 2:
            statusName = "免押中";
            break;
          case 3:
            statusName = "已完结";
            break;
          case 4:
            statusName = "已关闭";
            break;
          default:
            break;
        }

        this.statusTipName = statusName;
        this.statusName = res.statusName;
        this.expireTime = res.expireTime;
        this.timeoutTime = res.timeoutTime;
        this.completeTime = res.completeTime;
        this.remark = res.remark;
        this.createTime = res.createTime;
        this.completeTime = res.completeTime;

        if (res.status == 2) {
          this.requestButtonAction();
        }

        this.requestOrderAction();
      });
    },

    requestButtonAction() {
      getUnsecuredOrderDetailButton({
        orderNo: this.orderNo,
      }).then((res) => {
        this.buttonType = res;
        let tip = "";
        switch (res) {
          case 2:
            tip = "申请完结";
            break;
          case 3:
            tip = "申请完结审核中";
            break;
          case 4:
            tip = "申请拒绝重新申请";
            break;
        }
        this.buttonTitle = tip;
      });
    },

    requestOrderAction() {
      getListDeductionRecord({
        orderNo: this.orderNo,
        index: 1,
        pageSize: 99,
      }).then((res) => {
        let newItems = res.list || [];
        this.orderList = newItems.map((item) => {
          let statusClass = "default";
          switch (item.status) {
            case 1:
            case 5:
              statusClass = "warning";
              break;
            case 3:
            case 7:
              statusClass = "danger";
              break;
            case 2:
            case 6:
              statusClass = "success";
              break;
            case 4:
              statusClass = "cancel";
              break;
          }
          return {
            time: item.createTime,
            amount: item.amount,
            statusText: item.statusName || "",
            statusClass: statusClass,
          };
        });
      });
    },

    // [新增] 通用获取主题色并应用透明度的方法
    getThemeColor(opacity) {
      // 注意：getComputedStyle 在 SSR 或某些生命周期前可能获取不到，需确保 DOM 已挂载
      if (typeof window === "undefined")
        return `rgba(253, 141, 50, ${opacity})`;

      const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue("--primary-color")
        .trim();

      let r = 253,
        g = 141,
        b = 50; // 默认值

      if (primaryColor.startsWith("#")) {
        const hex = primaryColor.replace("#", "");
        if (hex.length === 3) {
          // 处理 #RGB 简写
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substr(0, 2), 16);
          g = parseInt(hex.substr(2, 2), 16);
          b = parseInt(hex.substr(4, 2), 16);
        }
      } else if (
        primaryColor.startsWith("rgba") ||
        primaryColor.startsWith("rgb")
      ) {
        const matches = primaryColor.match(/(\d+),\s*(\d+),\s*(\d+)/);
        if (matches) {
          r = parseInt(matches[1]);
          g = parseInt(matches[2]);
          b = parseInt(matches[3]);
        }
      }
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    },

    // 设置主题色阴影 CSS 变量 (保留原有逻辑，复用性优化)
    setPrimaryShadowVariables() {
      const color25 = this.getThemeColor(0.25);
      const color30 = this.getThemeColor(0.3);
      document.documentElement.style.setProperty(
        "--primary-shadow-25",
        color25
      );
      document.documentElement.style.setProperty(
        "--primary-shadow-30",
        color30
      );
    },

    showToast(msg) {
      this.toastMessage = msg;
      this.toastVisible = true;
      setTimeout(() => {
        this.toastVisible = false;
      }, 1500);
    },

    copyOrderNo() {
      const input = document.createElement("input");
      input.value = this.orderNo;
      input.setAttribute("readonly", "readonly");
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      if (input.setSelectionRange)
        input.setSelectionRange(0, input.value.length);
      try {
        if (document.execCommand("Copy")) this.showToast("复制成功");
        else this.showToast("复制失败");
      } catch (err) {
        this.showToast("复制失败");
      }
      document.body.removeChild(input);
    },

    handleSubmit() {
      if (this.buttonType == 2 || this.buttonType == 4) {
        this.finshShow = true;
      }
    },

    closeAlertAction() {
      this.finshShow = false;
    },
    cancelClick() {
      this.closeAlertAction();
    },
    okClick() {
      this.closeAlertAction();
      requestApplicationCompletedAction({ orderNo: this.orderNo }).then(() => {
        this.uni.navigateTo("/home/depositFreeFinnish"); // 假设原有跳转
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* 全局页面容器 */
.page-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.content {
  flex: 1;
  padding: 24px;
  padding-bottom: 120px;
}

/* --- 通用卡片样式 (圆角) --- */
.card {
  background: #fff;
  margin-bottom: 24px;
  overflow: hidden;
  border-radius: 16px;
}

/* --- 1. 头部卡片 --- */
.header-card {
  padding: 24px 32px;
}

.product-info {
  display: flex;
  align-items: center;
  margin-bottom: 60px; /* 留出空间给下方时间轴 */
}

.img-box {
  width: 132px;
  height: 132px;
  margin-right: 24px;
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
}
.img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info-text {
  flex: 1;
}

.card-title {
  font-size: 32px;
  margin-bottom: 40px;
  color: #24262b;
}

.prices-row {
  display: flex;
  gap: 40px;
  font-size: 30px;
  color: #848992;
  font-weight: bold;
}

.prices-row .price-item .bold {
  color: #24262b;
  font-weight: bold;
  margin-left: 4px;
  font-size: 30px;
  .price-item {
    color: #848992;
  }
}

/* --- 时间轴区域 (Flex布局：左-中-右) --- */
.timeline-box {
  display: flex;
  justify-content: space-between;
}

/* 左/右节点容器 */
.time-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  position: relative;
  z-index: 2;
}

/* 圆环 */
.hollow-ring {
  width: 34px;
  height: 34px;
  background-color: #fff;
  border: 4px solid var(--primary-color);
  border-radius: 17px;
  box-sizing: border-box;
  margin-bottom: 18px;
}

/* 文字 (开始/结束) */
.node-label {
  font-size: 26px;
  color: #848992;
  margin-bottom: 15px;
}

/* 日期 */
.node-date {
  font-size: 24px;
  color: #24262b;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* 中间进度条容器 */
.progress-container {
  flex: 1;
  position: relative;
  height: 12px;
  margin-left: -20px;
  margin-right: -20px;
  margin-top: 54px;
}

/* 进度线 */
.line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 12px;
  transform: translateY(-50%);
  z-index: 1;
  border-radius: 100px;
}

/* 胶囊 Badge */
.pill-badge {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(135deg, #fff 0%, #fefefe 100%);
  border: 4px solid var(--primary-color);
  color: var(--primary-color);
  font-size: 24px;
  font-weight: bold;
  padding: 10px 24px;
  border-radius: 120px;
  z-index: 3;
  white-space: nowrap;
}

/* --- 2. 免押信息列表 --- */
.info-list {
  padding: 0;
  /* 圆角已在 .card 中定义 */
}

.section-header {
  padding: 24px 32px;
  font-size: 32px;
  color: #000000;
}

.cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px 28px 32px;
  font-size: 28px;
}
.cell-label {
  color: #848992;
  width: 140px;
  flex-shrink: 0;
  font-size: 28px;
}

.cell-value {
  color: #24262b;
  flex: 1;
  text-align: right;
  word-break: break-all;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.flex-center img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.cell-tip1 {
  color: #1989fa;
  margin-left: 4px;
}
.cell-tip2 {
  color: #ff3831;
  margin-left: 4px;
}

.order-text {
  margin-right: 12px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px;
}
/* 复制按钮 - 纯CSS模拟 */
.copy-btn {
  border: 1px solid #848992;
  color: #848992;
  font-size: 20px;
  padding: 6px 16px;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  background: white;
}

.copy-btn:active {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  border-color: #ced4da;
  transform: scale(0.98);
}

/* --- 3. 扣款记录 --- */
.deduction-card {
  padding-bottom: 32px;
  /* 圆角已在 .card 中定义 */
}

.deduction-list {
  padding: 0 24px;
}

.deduction-item {
  background-color: #f7f8fa;
  border-radius: 8px; /* 内部小项也保持圆角 */
  padding: 24px;
  margin-bottom: 24px;
}
.deduction-item:last-child {
  margin-bottom: 0;
}

.d-time-row {
  font-size: 30px;
  color: #848992;
  margin-bottom: 16px;
}

.d-info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 30px;
}
.d-info-row:last-child {
  margin-bottom: 0;
}

.d-label {
  color: #848992;
}
.d-value.money {
  font-weight: bold;
  color: #000000;
}

/* 状态颜色 */
.status.warning {
  color: #ffb74c;
}
.status.success {
  color: #07c160;
}
.status.danger {
  color: #ee0a24;
}
.status.cancel {
  color: #999;
}
.status.default {
  color: #333;
}

/* --- 底部悬浮 --- */
/* --- 底部悬浮按钮 --- */
.footer-placeholder {
  height: 100px;
}

.footer-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 24px 32px;
  box-sizing: border-box;
  z-index: 100;
  /* 适配 iPhone X 底部黑条 */
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
}

.submit-btn {
  width: 100%;
  height: 88px;
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 16px;
  font-size: 32px;
  font-weight: bold;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  letter-spacing: 1px;
}

.submit-btn:active {
  opacity: 0.9;
  transform: scale(0.98);
  /* 使用 CSS 变量或 data 绑定的阴影 */
  box-shadow: 0 2px 8px var(--primary-shadow-25, rgba(253, 141, 50, 0.25));
}

/* --- 简易 Toast --- */
.custom-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 28px;
  z-index: 9999;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* --- 完结弹窗 --- */
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 580px;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
}
.block-tip {
  text-align: center;
  font-size: 34px;
  font-weight: bold;
  color: #333;
  margin-top: 48px;
}
.block-message {
  text-align: center;
  font-size: 30px;
  color: #666;
  margin: 32px 0 56px 0;
}
.button-group {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.btn-cancel,
.btn-confirm {
  flex: 1;
  height: 100px;
  border: none;
  background: #fff;
  font-size: 32px;
}
.btn-cancel {
  color: #999;
  border-right: 1px solid #f0f0f0;
}
.btn-confirm {
  color: var(--primary-color);
  font-weight: 500;
}
</style>
